var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16896 0.0488281C2.69468 0.45979 0 3.41521 0 7.00001C0 10.5848 2.69468 13.5402 6.16896 13.9512V11.5533C5.03733 11.28 4.07073 10.46 4 9.00001H5.29666C5.36149 9.78668 5.8389 10.4 7.05305 10.4C8.3556 10.4 8.6444 9.66668 8.6444 9.20668C8.6444 8.58668 8.3497 8.00001 6.87623 7.60001C5.23183 7.15335 4.10609 6.38668 4.10609 4.84668C4.10609 3.56001 5.02554 2.72001 6.16896 2.44001V0.0488281ZM7.93713 0.0621987V2.46001C9.16896 2.80001 9.78782 3.85334 9.82908 5.00001H8.52652C8.49116 4.16668 8.10216 3.60001 7.05305 3.60001C6.05697 3.60001 5.46169 4.10668 5.46169 4.83334C5.46169 5.46668 5.89194 5.87334 7.22986 6.26668C8.56778 6.66001 10 7.30668 10 9.20001C10 10.5667 9.08644 11.32 7.93713 11.5667V13.9378C11.36 13.4799 14 10.5482 14 7.00001C14 3.45179 11.36 0.520159 7.93713 0.0621987Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.7bb81540.svg";
export { ForwardRef as ReactComponent };